import { colors2, transition } from 'oolib';
import styled, { css } from 'styled-components';

export const StyledMyAccountMenuWrapper = styled.div`
  width: 100%;
  border-radius: 1.5rem;
  overflow: hidden;
  margin-bottom: 1.2rem;
  background-color: ${({ colors }) => colors?.secondaryContainer || colors2.secondaryContainer};
  color: ${({ colors }) => colors?.onSecondary || colors2.onSecondaryContainer};
`;

export const StyledMyAccountMenuTrigger = styled.button`
  width: 100%;
  border: none;
  background-color: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;

  cursor: pointer;
  
  ${({ open }) => open ? css`
    padding-bottom: 1.5rem;
  ` : null }

`;

export const StyledMyAccountMenuOptions = styled.div`
  width: 100%;
  border-radius: 0 0 1.5rem 1.5rem;
  overflow: hidden;
  padding: 0 1rem;
  max-height: ${({ open }) => (open ? '500px' : '0')};

  ${transition("max-height")} 

  animation: ${({ open }) =>  open ? 'slideDown 0.4s ease-in-out' : ''
    // 'slideUp 0.3s ease-in-out'
  };
  
  @keyframes slideDown {
    from {
      max-height: 0;
    }
    to {
      max-height: 500px;
    }
  }
  
  @keyframes slideUp {
    from {
      max-height: 500px;
    }
    to {
      max-height: 0;
    }
  } 
  
`;

export const StyledMyAccountMenuOption = styled.div`
  padding: 1rem 2rem;
  margin: 0 -1rem;
  cursor: pointer;
  &:hover {
    background-color: ${colors2.grey10};
  }
`;
